import { render, staticRenderFns } from "./ActGeometry__legend.vue?vue&type=template&id=3af1584c&scoped=true&"
import script from "./ActGeometry__legend.vue?vue&type=script&lang=js&"
export * from "./ActGeometry__legend.vue?vue&type=script&lang=js&"
import style0 from "./ActGeometry__legend.vue?vue&type=style&index=0&id=3af1584c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1584c",
  null
  
)

export default component.exports